<script>
export default {
  data() {
    return {};
  },
  computed: {
    brands() {
      return this.$store.state.brands;
    },
  },
};
</script>

<template>
  <section id="brands">
    <div class="container">
      <ul>
        <li
          v-for="(brand, index) in brands"
          :key="index"
          :class="`img-${index}`"
        >
          <a href.prevent>
            <img :src="require(`@/assets/images/restoque/${brand.img}`)" alt="" />
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
#brands {
  margin-top: 2rem;
  z-index: 99;
  position: relative;
  .container {
    border-bottom: 2px solid theme-color(primary);
    padding-bottom: 1.8rem;
    margin-bottom: 2rem;
  }
}

ul {
  background-color: transparent;
  border-radius: 3px;
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  @include media-breakpoint-down(sm) {
    overflow: auto;
    width: 100%;
    justify-content: flex-start;
  }

  li {
    margin: 0 35px;

    @include media-breakpoint-down(lg) {
      margin: 0 15px;
    }
    @include media-breakpoint-down(md) {
      margin: 0 10px;
    }
    @include media-breakpoint-down(sm) {
      margin: 0 10px;
      width: 25%;
      flex-shrink: 0;
    }
  }
}
</style>